import Cookies from 'js-cookie';

export const getConsultantIdentifier = () => {
  return Cookies.get('identifier') || null;
};